export enum AutomationRulesDataKeys {
    field = 'field',
    type = 'type',
    value = 'value',
    data = 'data',
    trigger = 'trigger',
    name = 'name',
    conditions = 'conditions',
    actions = 'actions',
}

export enum AutomationRulesTriggersWhen {
    operator_created = 'OPERATOR_CREATED',
}

export enum RuleTrigger {
    OPERATOR_CREATED = 'OPERATOR_CREATED',
}

export enum RuleConditionType {
    EQUALS = 'EQUALS',
    NOT_EQUALS = 'NOT_EQUALS',
}

export enum RuleActionType {
    enroll_training_program = 'ENROLL_TRAINING_PROGRAM',
    assign_location = 'ASSIGN_LOCATION',
}

export enum RuleConditionSourceFieldValues {
    ldap = 'LDAP',
    app = 'APP',
    hrms_op_import = 'HRMS_OP_IMPORT',
    csv_op_import = 'CSV_OP_IMPORT',
}

export enum TriggerConditions {
    source = 'OPERATOR_ORIGIN',
}

export enum TriggerExternalConditions {
    custom_field = 'OPERATOR_CUSTOM_FIELD',
}
